import { generatePath, useLocation } from "react-router";
import ActoRoutes from "@acto/taskpane/core/router/routes.config";
import { type NavDirection, useDirectionalNavigate } from "@acto/taskpane/field-sales-2/utils/viewTransitions";

export function useNavigateWithReturn(): (to: string, direction?: NavDirection) => void {
  const navigate = useDirectionalNavigate();
  const location = useLocation();
  const from = `${location.pathname}${location.search}`;

  return (to: string, direction: NavDirection = "push") => navigate(to, { state: { from }, direction });
}

export function useOpenCustomer(): (customerId: string) => void {
  const push = useNavigateWithReturn();

  return (customerId: string) =>
    push(generatePath(ActoRoutes.CUSTOMER_DETAILS, { id: encodeURIComponent(customerId) }));
}
